<div style="display: flex;align-items: center;gap: 5px;" *ngIf="cachedPinCounts">
  <app-pins-template-molecule [header]="header" [data]="data[header.field]" (fetchPinCount)="refreshPinCount()"
    [cachedPinCounts]="cachedPinCounts" style="margin-top: 3px;"></app-pins-template-molecule>&nbsp;
  {{ data[header.field] }}
</div>